export default {
  data() {
    return {
      lng: lng
    };
  },

  beforeCreate() {
    console.log('beforeCreate');
  },

  created() {
    console.log('created');
  },

  beforeMount() {
    console.log('beforeMount');
  },

  mounted() {
    console.log('mounted');
  },

  updated() {
    console.log('updated');
  },

  beforeDestroy() {
    console.log('beforeDestroy');
  },

  destroyed() {
    console.log('destroyed');
  },

  on: {
    pageMounted(e, page) {
      console.log('page mounted');
    },

    pageInit(e, page) {
      console.log('page init');
      console.log(e, page);
    },

    pageBeforeIn(e, page) {
      console.log('page before in');
    },

    pageAfterIn(e, page) {
      console.log('page after in');
    },

    pageBeforeOut(e, page) {
      console.log('page before out');
    },

    pageAfterOut(e, page) {
      console.log('page after out');
    },

    pageBeforeUnmount(e, page) {
      console.log('page before unmount');
    },

    pageBeforeRemove(e, page) {
      console.log('page before remove');
    }

  },
  methods: {},
  id: '6cb143d60c',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">Hotel</div>\n        <div class="right">\n          <a href="/">\n            <i class="icon f7-icons">house</i>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content bg-color-black">\n      <video playsinline autoplay muted loop id="myVideo">\n        <source src="static/video/pexels-cottonbro-6940833.mp4" type="video/mp4">\n      </video>\n      <div class="hotel-content">\n        <h1>Coming soon</h1>\n        <p>The Hotel module is in Progress.</p>\n        <p>Fill out the information request form and we will inform you of any \n          developments or other information you want and the launch date.</p>\n        <p>\n          <a href="https://infomycity.com/#contact" class="external button button-large button-outline" target="_system">Get info</a>\n        </p>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};